export const types = [
  {
    value: 'dog',
    text: 'Собака',
  },
];
